import React from 'react'
import { TextField } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import _ from 'lodash'

const SearchAndCreateList = ({ dispatch, lists }) => {
  const filterLists = _.debounce(async val => {
    dispatch({
      type: 'LOAD_LISTS_DONE',
      payload: lists.filter(l =>
        l.name.toLowerCase().includes(val.trim().toLowerCase())
      )
    })
  }, 500)

  return (
    <div
      className="mp-SearchAndCreateList"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        margin: '25px 0',
        position: 'relative',
        maxWidth: '533px'
      }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <SearchIcon
          style={{
            position: 'absolute',
            left: 0,
            top: 5,
            width: 17,
            height: 17,
            color: '#9D9D9D'
          }}
        />
        <TextField
          style={{ textIndent: '25px', width: '255px', height: '26px' }}
          placeholder="Search Lists"
          InputLabelProps={{ shrink: false }}
          inputProps={{
            style: {
              color: '#393939',
              height: '26px',
              padding: 0,
              paddingLeft: '20px',
              font: 'normal 14px Roboto'
            }
          }}
          onChange={event => {
            event.persist()
            filterLists(event.target.value)
          }}
        />
      </div>
    </div>
  )
}

export default SearchAndCreateList
